import { useMatches } from "react-router-dom";

import { isRecord } from "@/apps/admin/utilities/typeGuard";

// `href` is null for a section with no page of its own (a handle with `hasPage: false`)
export type RouteCrumb = { label: string; href: string | null };

/** A route handle's `defaultQueryParams` as a search string, so a crumb opens the page as its links do. */
const searchFromDefaultQueryParams = (params: unknown): string => {
  if (!isRecord(params)) {
    return "";
  }
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") {
      searchParams.set(key, String(value));
    }
  }
  const search = searchParams.toString();
  return search ? `?${search}` : "";
};

/**
 * The trail of the matched routes that have a title, root excluded: the top bar draws it, and a
 * page header takes the last one as its default title. An index route matches a second time
 * with a trailing slash, and is dropped.
 */
export const useRouteTrail = (): RouteCrumb[] =>
  useMatches()
    .slice(1)
    .filter(({ pathname }) => !/^\/.+\/$/.test(pathname))
    .flatMap(({ pathname, handle }) => {
      if (!isRecord(handle) || typeof handle.title !== "string") {
        return [];
      }
      return [
        {
          label: handle.title,
          href:
            handle.hasPage === false
              ? null
              : `${pathname}${searchFromDefaultQueryParams(handle.defaultQueryParams)}`,
        },
      ];
    });
